import React, { useEffect, useState } from "react"
import useReportColumns from "hooks/useReportColumns"
import { REPORT_COLUMN_KEYS } from "config/reportColumnDefinitions"

import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { useDispatch, useSelector } from "react-redux"
import {
  exportMonitorQuantificationReport,
  getMonitorQuantificationReport,
} from "store/monitor-reports/monitor-report-action"
import {
  getMonitorIps,
  getMonitorItemCategories,
  getMonitorProjects,
} from "store/monitor-dashboard/monitor-dashboard-action"
import MonitorQuantificationReportListComponent from "components/MonitorReports/Quantification"

const MonitorQuantificationReport = () => {
  //meta title
  document.title = "Quantification Report"

  const [params, setParams] = useState({})
  const { data, error, loading, exportStatus } = useSelector(state => ({
    data: state.monitorReports.monitorQuantificationReport.data,
    error: state.monitorReports.monitorQuantificationReport.error,
    loading: state.monitorReports.monitorQuantificationReport.loading,
    exportStatus: state.monitorReports.monitorQuantificationExport,
  }))

  const dispatch = useDispatch()
  const { columns, visibleColumns, visibleKeys, toggleColumn } = useReportColumns(
    REPORT_COLUMN_KEYS.MONITOR_QUANTIFICATION
  )

  // Trigger export process when Export button is clicked
  const onExport = () => {
    dispatch(exportMonitorQuantificationReport(params, visibleKeys))
  }

  // Fetch Quantification Report and other data based filter selebox needs
  useEffect(() => {
    dispatch(getMonitorQuantificationReport())
    dispatch(getMonitorProjects())
    dispatch(getMonitorItemCategories())
    dispatch(getMonitorIps())
  }, [])

  // Updates search value when a new search is performed
  const onSearchHandler = filter => {
    setParams(filter)
    dispatch(getMonitorQuantificationReport(filter))
  }

  return (
    <React.Fragment>
      <Breadcrumbs title={"Monitor"} breadcrumbItem={"Quantification Report"} />
      {/* Monitor Quantification Report Component   */}
      <MonitorQuantificationReportListComponent
        data={data}
        error={error}
        loading={loading}
        onSearchHandler={onSearchHandler}
        onExportBtnClick={onExport}
        exportStatus={exportStatus}
        columns={columns}
        visibleColumns={visibleColumns}
        onToggleColumn={toggleColumn}
      />
    </React.Fragment>
  )
}

export default MonitorQuantificationReport
